/**
 * Site-wide metadata and JSON-LD (Schema.org) for search engines and social sharing.
 * Update siteUrl when you have a production domain.
 */

export const siteMetadata = {
  name: "Showelli",
  tagline: "Bespoke Entertainment",
  description:
    "Bespoke entertainment tailored to your event—from individual performers to fully curated shows. Dancers, aerialists, musicians, singers, fire performers, and immersive productions for private parties, corporate events, weddings, and residencies.",
  /** Update this to your production URL for correct canonical/og:url when deployed */
  siteUrl: "https://showelli.com",
  logoUrl: "/images/showelli-logo.png",
  ogImageUrl: "/images/landing.jpeg",
  keywords:
    "Showelli, dancers, performers, choreography, music videos, concerts, backup dancers, entertainment, fire performers, bespoke entertainment, corporate events, weddings",
} as const;

/**
 * JSON-LD Organization schema for Google and other search engines.
 * @see https://developers.google.com/search/docs/appearance/structured-data/organization
 */
export function getOrganizationJsonLd() {
  const baseUrl = siteMetadata.siteUrl;
  const logoUrl = baseUrl + siteMetadata.logoUrl;

  return {
    "@context": "https://schema.org",
    "@type": "PerformingGroup",
    name: siteMetadata.name,
    description: siteMetadata.description,
    url: baseUrl,
    logo: {
      "@type": "ImageObject",
      url: logoUrl,
    },
  };
}
